import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ClientContextService } from '../../../../services/ClientContextService';

declare var jQuery: any;//working with on page elemts outside of the angular control is easier with jQuery :S kinda sucks but better then hacking together old school selectors

@Component({
  selector: 'app-translation',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'FRTranslation';

  //variable set by iMIS when the language toggles
    gCurrentCultureCode: string;
    isFrench: boolean = false;

  languageLink: Element; 

  constructor(@Inject(DOCUMENT) private document: Document, private clientContect: ClientContextService) {
      this.languageLink = document.getElementsByClassName("language-link")[0];

      this.gCurrentCultureCode = "en";

      if (window["__cultureInfo"] !== undefined && window["__cultureInfo"].name.toLowerCase() === "fr") {
          this.gCurrentCultureCode = "fr-FR";
      }

      //what site are we on? if the english text is shown then we are on the french site
      if (this.languageLink.textContent.trim().toLowerCase() === "english") {
          this.isFrench = true;
      }
  }

  ngOnInit(): void {

    //hide the toggle
    (function ($) {
      $(document).ready(function () {
        $(".UtilityTranslation").css("display", "none");
      });
    })(jQuery);

      //are we on the french site?
      if (this.isFrench) {
          //is the culture set to french?
          if (this.gCurrentCultureCode !== "fr-FR") { //no we a re not turn on the french translation
              (function ($) {
                  $("[name$='CultureDropDownList'] option[value=fr]").prop('selected', true);
                  $("[name$='CultureDropDownList']").trigger('change');
              })(jQuery);
          } else { //french is set lets load our internal library
              this._loadScript(
                  `${this.clientContect.GetBaseUrl()}Areas/FRTranslation/assets/Lingumania.js`,
                  this._scriptLoaded.bind(this, !0),
                  this._scriptLoaded.bind(this, !1)
              );
          }
      } else {
          //are we set to english?
          if (this.gCurrentCultureCode === "fr-FR") {// no we are not set turn on english
              (function ($) {
                  $("[name$='CultureDropDownList'] option[value=en-US]").prop('selected', true);
                  $("[name$='CultureDropDownList']").trigger('change');
              })(jQuery);
          }
      }

  }

  _loadScript(scriptSrcUrl, onLoadSuccessCallback, onErrorCallback) {
    if (scriptSrcUrl)
      if (document.querySelector('script[src="' + scriptSrcUrl + '"]')) {
        onLoadSuccessCallback();
      } else {
        var a = document.createElement('script');
        a.setAttribute('async', ''),
          (a.src = scriptSrcUrl),
          onLoadSuccessCallback && (a.onload = onLoadSuccessCallback),
          onErrorCallback && (a.onerror = onErrorCallback),
          document.head.appendChild(a);
      }
  }

  _scriptLoaded(result) {
    if (result) {
      // use the script
    } else {
      // handleError
    }
  }


}
